import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import { useAdminApi } from "./useAdminApi";
import { assetUrl, errMsg } from "@/lib/api";

export const ImageField = ({ value, onChange, testid = "image-field", accept = "image/*" }) => {
  const api = useAdminApi();
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { url } = await api("post", "/admin/upload", fd);
      onChange(url);
      toast.success("Uploaded");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="flex gap-3 items-start">
      {accept.startsWith("video") ? null : value ? <img src={assetUrl(value)} alt="" className="w-16 h-16 object-cover border border-mas-sand shrink-0" /> : <div className="w-16 h-16 bg-mas-paper border border-mas-sand shrink-0" />}
      <div className="flex-1 space-y-2">
        <input className="field" value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={accept.startsWith("video") ? "YouTube / Vimeo link, video URL, or upload" : "Image URL or upload"} data-testid={`${testid}-url-input`} />
        <input ref={ref} type="file" accept={accept} className="hidden" onChange={(e) => upload(e.target.files[0])} data-testid={`${testid}-file-input`} />
        <button type="button" onClick={() => ref.current.click()} disabled={busy} className="btn-ink !py-1.5 !px-3 !text-xs" data-testid={`${testid}-upload-button`}>
          <Upload className="w-3.5 h-3.5" />{busy ? "Uploading..." : accept.startsWith("video") ? "Upload video (max 100MB)" : "Upload image"}
        </button>
      </div>
    </div>
  );
};
